// Structured Data (JSON-LD) generators

export const generateLocalBusiness = () => ({
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "WellTec - Locações e Serviços Técnicos",
  "@id": "https://www.wellttec.com",
  "url": "https://www.wellttec.com",
  "telephone": "+5531971823249",
  "priceRange": "$$",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Rua João de Carvalho Silva, 274",
    "addressLocality": "São Tarcísio, Mário Campos",
    "addressRegion": "MG",
    "postalCode": "32220-000",
    "addressCountry": "BR"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": -20.0553,
    "longitude": -44.1358
  },
  "openingHoursSpecification": {
    "@type": "OpeningHoursSpecification",
    "dayOfWeek": [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday"
    ],
    "opens": "08:00",
    "closes": "18:00"
  },
  "sameAs": [
    "https://www.instagram.com/welltecbrasil/"
  ]
});

export const generateFAQPage = (faqItems) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": faqItems.map(item => ({
    "@type": "Question",
    "name": item.question,
    "acceptedAnswer": {
      "@type": "Answer",
      "text": item.answer
    }
  }))
});

export const generateArticle = (title, description, publishedDate, modifiedDate) => ({
  "@context": "https://schema.org",
  "@type": "Article",
  "headline": title,
  "description": description,
  "datePublished": publishedDate || "2024-08-15",
  "dateModified": modifiedDate || new Date().toISOString().split('T')[0],
  "author": {
    "@type": "Organization",
    "name": "WellTec"
  },
  "publisher": {
    "@type": "Organization",
    "name": "WellTec",
    "logo": {
      "@type": "ImageObject",
      "url": "https://www.wellttec.com/og-image.jpg"
    }
  }
});

export const generateService = (serviceName, description, areaServed) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  "serviceType": serviceName,
  "description": description,
  "provider": {
    "@type": "LocalBusiness",
    "name": "WellTec",
    "telephone": "+5531971823249"
  },
  "areaServed": Array.isArray(areaServed) ? areaServed.map(city => ({
    "@type": "City",
    "name": city
  })) : {
    "@type": "City",
    "name": areaServed
  }
});
